'use client';

import { Modal } from '../Modal/Modal';
// TODO: dynamically import this component once migrated into de-sxm-www
import { FocusTrap } from 'focus-trap-react';
import { VideoPlayer } from '../Media/Video/VideoPlayer';
import { VideoProps } from '../Media/Video/Video';
import { IconVideoPlayButton } from '@/assets/icons/IconVideoPlayButton';
import styles from './herovideo.module.scss';
import { useRef, useState } from 'react';
import useViewportWidth from '@/hooks/useViewportWidth';
import useClickOutside from '@/hooks/useClickOutside';

const MODAL_CLICK_THROUGH_EXCEPTIONS_SELECTOR = '#onetrust-consent-sdk';

export interface HeroVideoModalProps {
    source: VideoProps['source'];
    altText: VideoProps['altText'];
    videoId: VideoProps['videoId'];
    copyright: VideoProps['copyright'];
    transcript: VideoProps['transcript'];
    hidePlayerText?: boolean;
    captionSrc?: VideoProps['captionSrc'];
}

export function HeroVideoModal({ source, videoId, hidePlayerText = false, captionSrc }: HeroVideoModalProps) {
    const [modalOpen, setModalOpen] = useState<boolean>(false);
    const [focusPause, setFocusPause] = useState(false);
    const ref = useRef<HTMLDivElement>(null);
    const viewportWidth = useViewportWidth();

    const onModalTriggerClick = () => {
        setModalOpen(true);
    };

    const onModalClose = () => {
        setModalOpen(false);
    };

    useClickOutside(ref, {}, (state, event) => {
        if (event) {
            if (event.target) {
                const target = event.target as HTMLElement;
                const closest = target.closest(MODAL_CLICK_THROUGH_EXCEPTIONS_SELECTOR);
                setFocusPause(!!closest);
            }
        }
    });

    return (
        <>
            <div
                className={styles.videoPlayerButton}
                onClick={onModalTriggerClick}
                role="button"
                aria-label="play video"
                tabIndex={0}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        onModalTriggerClick();
                    }
                }}
            >
                {!hidePlayerText && <span className={styles.playButtonText}>Play Video</span>}
                <div className={styles.playButton}>
                    <IconVideoPlayButton />
                </div>
            </div>

            {modalOpen && (
                <FocusTrap
                    active={modalOpen}
                    paused={focusPause}
                    focusTrapOptions={{
                        allowOutsideClick: true,
                    }}
                >
                    <Modal
                        ref={ref}
                        variant="video"
                        maxWidth={viewportWidth < 1188 ? viewportWidth : 1188}
                        backgroundTransparent={true}
                        open={modalOpen}
                        onClose={onModalClose}
                        dataLocalpagename={videoId ? 'overlay:youtubevideo' : 'overlay:hostedvideo'}
                    >
                        <VideoPlayer
                            source={source}
                            className={styles.videoModal}
                            activeVideo={true}
                            resumeFromLastTime={true}
                            initiatePlayer
                            captionSrc={captionSrc}
                        />
                    </Modal>
                </FocusTrap>
            )}
        </>
    );
}
